const checkboxes = document.querySelectorAll('.wpgmza_checkbox');
if (checkboxes) {
  Array.from(checkboxes).forEach((checkbox) => {
    checkbox.addEventListener('click', () => {
      if (checkbox.checked) {
        checkbox.parentElement.classList.add('cat-checkbox-fern--active');
      } else if (checkbox.parentElement.classList.contains('cat-checkbox-fern--active')) {
        checkbox.parentElement.classList.remove('cat-checkbox-fern--active');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  function checkMapChildClasses() {
    const categoryFilterElements = document.querySelectorAll(
      '.wpgmza_modern_infowindow.wpgmza-shadow',
    );
    const mapElement = document.querySelector('.wpgmza_map');
    if (mapElement) {
      if (categoryFilterElements.length > 0) {
        mapElement.classList.add('no-filter');
      } else {
        mapElement.classList.remove('no-filter');
      }
    }
  }
  const observer = new MutationObserver(checkMapChildClasses);
  const targetNode = document.body;

  const config = {
    childList: true,
    subtree: true,
  };

  observer.observe(targetNode, config);

  checkMapChildClasses();
});
